import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { ICity } from "../../models/BaseModel";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Search } from "../../shared/Search";
import { IOpenForm } from "./City";
import { format } from "date-fns";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { ImageGalleryDialog } from "./Gallery";
import { CitySpot } from "./CitySpot";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";

interface Iprops {
    setModal: (modal: IOpenForm) => void,
    toast: any,
    reload: boolean,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Table = (props: Iprops) => {
    const [expandedRows, setExpandedRows] = useState<{ [key: string]: boolean }>({});
    const [expandedSections, setExpandedSections] = useState<{ [rowId: string]: { citySpot?: boolean; } }>({});
    const [tableData, setTableData] = useState({ data: [], count: 0, loading: false } as { data: ICity[], count: number, loading: boolean });
    const [imageDialog, setImageDialog] = useState<{ open: boolean; images: { id: number; imageFileName: string }[]; title?: string; Id?: number; }>({ open: false, images: [], title: '', Id: undefined });
    const [openselectImages, setOpenselectImages] = useState<{ open: boolean; Id?: number; singleData: any }>({ open: false, Id: undefined, singleData: {} });
    const [spots, setSpots] = useState<any[]>([]);
    const [selectedImageIds, setSelectedImageIds] = useState<number[]>([]);


    const [openCitySpot, setOpenCitySpot] = useState<{
        open: boolean;
        images: { id: number; imageFileName: string }[];
        title?: string;
        Id?: number;
    }>({ open: false, images: [], title: '', Id: undefined });


    const showRoomImages = async (rowData: any) => {
        const response = await Fetch(`City/GetCityImages?cityId=${rowData.id}`, "GET", null, null, props.toast);
        if (response) {
            const images: { imageFileName: string; id: number }[] = await response.json();
            setImageDialog({ open: true, images, title: rowData.title, Id: rowData.id });
        }
    };

    const [text, setText] = useState<string | null>(null);
    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'id',
        sortOrder: -1
    });

    useEffect(() => {
        loadTableData();
    }, [text, lazyParams, props.reload]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch("city", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}${text ? '&text=' + text : ''}`, props.toast);
        if (response) {
            const data: { cities: ICity[], count: number } = await response.json();
            setTableData({ data: data.cities, count: data.count, loading: false });
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: { isTouristDestination: false } });
    };

    const openEdit = (rowDatauser: ICity) => {
        props.setModal({ open: true, singleData: rowDatauser });
    };

    const Remove = async (rowData: ICity) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`city/${rowData.id}`, "DELETE", null, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "City Deleted", life: 3000 });
            loadTableData();
        }
    }

    const rejectFunc = () => { }

    const confirmDelete = (rowData: ICity) => {
        confirmDialog({
            message: `Are you sure you want to delete "${rowData.name}"?`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => Remove(rowData),
            reject: () => rejectFunc()
        });
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4">
            <div className="flex gap-4 w-full">
                {props.hasPermission("City", "Add") && (
                    <Button style={{ width: '80px', height: '30px' }} label="New" icon="pi pi-plus" className="p-button-sm p-button-rounded p-button-success" onClick={openNew} />
                )}
                <div className="w-full flex align-items-center justify-content-center">
                    <h4 style={{ margin: 0, textTransform: 'uppercase', fontFamily: 'Rancho', letterSpacing: 1 }}>City</h4>
                </div>
            </div>
            <div className="flex gap-4">
                <div className="p-input-icon-left">
                    <Search setSearch={setText} />
                </div>
                {props.hasPermission("City", "Export") && (
                    <Button style={{ width: '80px', height: '30px' }} label="Export" icon="pi pi-upload" className="p-button-sm p-button-rounded p-button-help" onClick={exportCSV} />
                )}
            </div>
        </div>
    );

    const openAddcitySpotImages = (rowData: any) => {
        setOpenCitySpot({ open: true, images: [], title: rowData.name, Id: rowData.id });
        toggleSection(rowData.id, 'citySpot');
    };

    const actionBodyTemplate = (rowData: any) => {
        return (
            <div className="actions">
                {props.hasPermission("City", "Edit") && <Button icon="pi pi-pencil" className='p-button-success p-button-text p-0' onClick={() => openEdit(rowData)} />}
                {props.hasPermission("City", "Remove") && <Button icon="pi pi-trash" className='p-button-danger p-button-text p-0' onClick={() => { confirmDelete(rowData) }} ></Button>}
                {rowData.isTouristDestination && <Button icon="pi pi-building" className="p-button-success p-button-text p-0" tooltip="See Arrange" onClick={() => { setOpenselectImages({ open: true, Id: rowData.id, singleData: rowData }); loadSpots(rowData.id) }} />}
                {/* <Button icon="pi pi-image" className="p-button-success p-button-text p-0" tooltip="View Images" onClick={() => showRoomImages(rowData)} /> */}
                {rowData.isTouristDestination &&<Button icon="pi pi-plus" className="p-button-success p-button-text p-0" tooltip="Add Spot" onClick={() => toggleSection(rowData.id, 'citySpot')} />}
                {/* <Button icon="pi pi-plus" className="p-button-success p-button-text p-0" tooltip="Add Spot" onClick={() => toggleSection(rowData.id, 'citySpot')} /> */}


            </div>
        );
    };

    const toggleStatus = async (id: number) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`city/toggleTouristStatus/${id}`, "PUT", null, null, props.toast);
        if (response) {
            setTableData(prev => ({ ...prev, loading: false, data: prev.data.map(d => d.id === id ? { ...d, isTouristDestination: !d.isTouristDestination } : d) }));
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }
    const statusBody = (rowData: ICity) => {
        return (
            <div className="flex align-items-center gap-2">
                <i className={`pi ${rowData.isTouristDestination ? 'pi-check-circle' : 'pi-times-circle'}`} style={{ color: rowData.isTouristDestination ? '#4caf50' : '#f44336' }}></i>
                <span onClick={() => { if (rowData.id) toggleStatus(rowData.id) }} className="cursor-pointer">{rowData.isTouristDestination ? 'Yes' : 'No'}</span>
            </div>
        );
    }

    const toggleDisplayHome = async (id: number) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`city/toggleCityDisplayHome/${id}`, "PUT", null, null, props.toast);
        if (response) {
            setTableData(prev => ({ ...prev, loading: false, data: prev.data.map(d => d.id === id ? { ...d, isDisplayHome: !d.isDisplayHome } : d) }));
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }

    const statusDisplayHome = (rowData: ICity) => {
        return (
            <div className="flex align-items-center gap-2">
                <i className={`pi ${rowData.isDisplayHome ? 'pi-check-circle' : 'pi-times-circle'}`} style={{ color: rowData.isDisplayHome ? '#4caf50' : '#f44336' }}></i>
                <span onClick={() => { if (rowData.id) toggleDisplayHome(rowData.id) }} className="cursor-pointer">{rowData.isDisplayHome ? 'Yes' : 'No'}</span>
            </div>
        );
    }

    const toggleSection = (hotelId: number, section: 'citySpot') => {
        setExpandedSections(prev => {
            const current = prev[hotelId] || {};
            const isCurrentlyOpen = !!current[section];
            const newSections = {
                [section]: !isCurrentlyOpen,
                citySpot1: section === 'citySpot' ? !isCurrentlyOpen : false,

            };

            const updated = { ...prev, [hotelId]: newSections };

            const isAnySectionOpen = Object.values(newSections).some(Boolean);
            setExpandedRows(prevExpanded => ({
                ...prevExpanded,
                [hotelId]: isAnySectionOpen
            }));

            return updated;
        });
    };

    const rowExpansionTemplate = (hotel: any) => {
        const rowExpanded = expandedSections[hotel.id] || {};
        return (
            <>
                {rowExpanded.citySpot && <CitySpot visible={true} onHide={() => toggleSection(hotel.id, "citySpot")} hotel={hotel}
                    images={openCitySpot.images} toast={props.toast} reloadImages={() => openAddcitySpotImages({ id: openCitySpot.Id, title: openCitySpot.title })} />}

            </>
        );
    };

    const onHide1 = () => {
        setOpenselectImages({ open: false, Id: 0, singleData: {} });
    };


    const loadSpots = async (cityId?: number) => {
        if (!cityId) return;

        // 1. Load all spots for this city
        const response = await Fetch(`City/GetSpots/${cityId}`, "GET", null, null, props.toast);
        let allSpots: any[] = [];
        if (response) {
            allSpots = await response.json();
            setSpots(allSpots);
        }

        // 2. Load selected spot IDs
        const selectedResponse = await Fetch(`City/GetCitySpotImages/${cityId}`, "GET", null, null, props.toast);
        if (selectedResponse) {
            const selectedIds: number[] = await selectedResponse.json();
            setSelectedImageIds(selectedIds); // ✅ pre-check the checkboxes
        }
    };


    const toggleStatus1 = async (id: number) => {
        if (!id) return;
        // Immediately update local state for UI responsiveness
        setSpots(prevSpots => prevSpots.map(spot =>
            spot.id === id ? { ...spot, isActive: !spot.isActive } : spot)
        );
        // Then make API call to persist the change
        const response = await Fetch(`city/toggleCitySpotsStatus/${id}`, "PUT", null, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: "success", summary: "Saved", detail: "Status changed successfully", life: 3000, });
        } else {
            // Rollback if API failed
            setSpots(prevSpots => prevSpots.map(spot => spot.id === id ? { ...spot, isActive: !spot.isActive } : spot
            )
            );
        }
    }

    const toggleSpotSelection = (id: number) => {
        setSelectedImageIds((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };

    const handleSave = async () => {
        const payload = { CityId: openselectImages.singleData?.id, Spots: selectedImageIds, };
        const response = await Fetch("City/selectSpotImageforCity", "POST", payload, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: "success", summary: "Saved", detail: "City spots saved successfully.", life: 3000, });
            onHide1();
        }
    };


    return (
        <>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" scrollHeight="70vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.data} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={tableData.count} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
                expandedRows={expandedRows}
                onRowToggle={(e: any) => setExpandedRows(e.data)}
                rowExpansionTemplate={rowExpansionTemplate}
            >
                <Column field="name" header="City Name" sortable />
                <Column field="stateName" header="State" sortable />
                <Column field="countryName" header="Country" sortable />
                <Column field="isTouristDestination" header="IsTouristDestination" sortable body={statusBody} />
                <Column field="isDisplayHome" header="IsDisplayHome" sortable body={statusDisplayHome} />
                <Column body={actionBodyTemplate} />
            </DataTable>
            <ConfirmDialog />
            <ImageGalleryDialog visible={imageDialog.open} onHide={() => setImageDialog((prev) => ({ ...prev, open: false }))} images={imageDialog.images}
                title={imageDialog.title} roomId={imageDialog.Id ?? 0} toast={props.toast} reloadImages={() => showRoomImages({ id: imageDialog.Id, title: imageDialog.title })} />
            {/* <CitySpot visible={openCitySpot.open} onHide={() => setOpenCitySpot((prev) => ({ ...prev, open: false }))}
                images={openCitySpot.images} roomId={openCitySpot.Id ?? 0} toast={props.toast} reloadImages={() => openAddcitySpotImages({ id: openCitySpot.Id, title: openCitySpot.title })}
            /> */}
            {/* Select Images For city Images */}
            <Dialog visible={openselectImages.open} header={
                <span style={{ color: "#007ad9", fontWeight: "600" }}>
                    Select Spots Image for {openselectImages.singleData?.name}
                </span>
            } style={{ width: "40vw" }} onHide={onHide1} >
                <div className="p-3">
                    {spots.length === 0 ? (
                        <div className="flex flex-column align-items-center justify-content-center text-center" style={{ height: "40vh" }} >
                            <i className="pi pi-info-circle text-4xl text-gray-500 mb-3"></i>
                            <span className="text-lg text-gray-600 font-medium">
                                No spots added for {openselectImages.singleData?.name}.
                            </span>
                        </div>
                    ) : (
                        <div className="flex flex-column gap-3" style={{ maxHeight: "60vh", overflowY: "auto" }}
                        >
                            {spots.map((spot: any, index: number) => (
                                <div
                                    key={index}
                                    className="flex align-items-center justify-content-between p-3 border-round surface-card shadow-1 hover:shadow-2 transition-all"
                                >
                                    <div className="flex align-items-center gap-3">
                                        <i className="pi pi-images text-primary text-xl"></i>
                                        <span className="text-md font-medium">{spot.title}</span>
                                    </div>
                                    <div className="flex align-items-center gap-2">
                                        <Checkbox
                                            inputId={`spot-${spot.id}`}
                                            checked={selectedImageIds.includes(spot.id)}
                                            onChange={() => toggleSpotSelection(spot.id)}
                                        />
                                        <label htmlFor={`spot-${spot.id}`} className="cursor-pointer">
                                            Select
                                        </label>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    <div className="col-12 md:col-12 flex gap-4 justify-content-end -mb-6 ml-0 mt-4">
                        <Button style={{ width: "100px" }} onClick={handleSave} label="SAVE" type="submit" className="p-button-rounded" disabled={spots.length === 0} />
                        <Button style={{ width: "100px" }} label="CLOSE" onClick={onHide1} type="button" className="p-button-rounded p-button-outlined surface-200"
                        />
                    </div>
                </div>
            </Dialog>

        </>
    );
}
